import { imageFile } from 'common/helpers/miscHelpers';

const Image = (props) => {
  const { item } = props;

  return (
    <div className="c7-order-item__image">
      <img src={imageFile(item.image, 'small')} alt="" />
    </div>
  );
};

export default Image;
